import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Dumbbell, Brain, Compass, Clock, RefreshCw, TrendingUp } from 'lucide-react';
const contents = [{
  icon: BookOpen,
  text: 'Un plan completo de 30 días paso a paso'
}, {
  icon: Dumbbell,
  text: 'Rutinas simples para mejorar tu cuerpo sin complicarte'
}, {
  icon: Brain,
  text: 'Ejercicios prácticos para cambiar tu mentalidad'
}, {
  icon: Compass,
  text: 'Sistema claro para construir disciplina desde cero'
}, {
  icon: Clock,
  text: 'Organización diaria para aprovechar mejor tu tiempo'
}, {
  icon: RefreshCw,
  text: 'Hábitos clave para generar un cambio real y sostenible'
}, {
  icon: TrendingUp,
  text: 'Estrategias para mantener el progreso y no abandonar'
}];
export function WhatYouGet() {
  return <section className="py-20 md:py-28 px-4 bg-cream" data-id="element-245">
      <div className="max-w-4xl mx-auto" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-247">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6" data-id="element-248">
            ¿Qué incluye el producto?
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto" data-id="element-249">
            Dentro de{' '}
            <span className="font-bold italic text-primary" data-id="element-250">
              Irreconocible en 30 Días
            </span>{' '}
            vas a encontrar:
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-251">
          {contents.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-4 bg-white p-4 md:p-6 rounded-xl shadow-sm border border-border hover:shadow-md transition-shadow" data-id="element-252">
                <div className="bg-beige p-3 rounded-lg shrink-0" data-id="element-253">
                  <Icon className="w-6 h-6 text-nude-dark" data-id="element-254" />
                </div>
                <p className="text-primary font-medium text-lg" data-id="element-255">{item.text}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 text-center bg-highlight/20 p-6 rounded-2xl border border-highlight/50" data-id="element-256">
          <p className="text-xl font-serif italic text-primary" data-id="element-257">
            Todo explicado de forma simple, directa y fácil de aplicar desde el
            primer día.
          </p>
        </motion.div>
      </div>
    </section>;
}